import request from '@/utils/request'

let Register_registerApi = {

  /*报名列表*/
  list(data) {
    return request._post('/shop/plus.register_register.Index/index', data);
},
getJzList(data){
    return request._post('/shop/plus.register_register.Index/getjzmenu', data);
},
/*添加报名*/
add(data) {
    return request._post('/shop/plus.register_register.Index/add', data);
},
/*修改报名*/
edit(data) {
    return request._post('/shop/plus.register_register.Index/edit', data);
},
/*删除报名*/
del(data) {
    return request._post('/shop/plus.register_register.Index/del', data);
},
/*报名详情*/
detail(data) {
  return request._post('/shop/plus.register_register.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.register_register.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.register_register.Setting/getSetting', data, errorback);
    },
}
export default Register_registerApi;



// WEBPACK FOOTER //
// ./src/api/register_register.js